import React from 'react';
import { connect } from 'react-redux';
import { Modal, Text, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { numberWithCommas } from "../../services/helpers";

/**
 *
 * @param {*} param0
 */
const HealthSpendingModal = ({ 
    amountSubmitted, 
    amountClaimed, 
    patient, 
    completeClaim, 
    useHSA, 
    healthSpendRemaining, 
    isProcessingTopOff,
    onClose,
    loader
}) => {
    const remaining = numberWithCommas((amountSubmitted - amountClaimed));

    return (
        <Modal
            open={true}
            onClose={ onClose }
            loader={ loader }
            title={ i18n.t(tokens.labels.claims.wantATopOff) }
            primaryButton={{
                label: i18n.t(tokens.buttons.yes),
                onClick: isProcessingTopOff ? null : useHSA
            }}
            secondaryButton={{
                label: i18n.t(tokens.buttons.no),
                onClick: completeClaim
            }}
        >
            <Text
                display="block"
                margin="10px 0 0 0"
                medium
            >
                { i18n.t(tokens.labels.claims.claimAmountDetails, { amountClaimed: numberWithCommas(amountClaimed), patient, remaining, healthSpendRemaining: healthSpendRemaining.toFixed(2) }) }
            </Text>
        </Modal>
    );
};

export default connect()(HealthSpendingModal);